export const MOBILE_NUMBER = /^(?!0|1|2|3|4|5)[0-9]{1,10}$/;
export const ALPHABETS_ONLY = /^[a-zA-Z]*$/;
export const EMAILID =
  /^[a-zA-Z\d](?:(?!.*[_.-]{2})[a-zA-Z\d._-])*@[a-zA-Z\d](?:(?!.*[-]{2})[a-zA-Z\d.-])*\.[a-zA-Z]{2,}$/;
export const NUMBER = /^[0-9]*$/;
export const PROFILE_NAME_FIELD = /^[A-Z][a-zA-Z]{2,15}$/;
export const WEBSITE = /^(https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/[^\s]*)?$/;
export const POSTAL_CODE = /^[1-9][0-9]{5}$/;
export const PANCARD = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/;
export const NAME = /^[A-Za-z]+(?:.*[\sA-Za-z])+[A-Za-z]$/;
export const GSTIN = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[zZ][0-9A-Za-z]{1}$/;
export const CIN = /^[LU][0-9]{5}[a-zA-Z]{2}[0-9]{4}[a-zA-Z]{3}[0-9]{6}$/;
export const REPEATDIGIT = /(\d)\1{9}/;
export const DISCUSS = /^(\w*\s*[\#\-\,\/\.\(\)\&]*)+$/;
export const ORGANISATION = /^[A-Za-z0-9][A-Za-z0-9\s]{2,49}$/;
export const ADDRESS = /^.{3,200}$/;
export const regEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
